import Debug from 'debug';

export const debugTracking = Debug('tracking');
